// React
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { previewDocuments } from 'aurora-composition/modules/common/actions';
import { COMMON_REDUCER_CLEAR_ERROR } from 'aurora-composition/modules/common/constants';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { Loading, ADGMSnackbar, ADGMResponsiveModal } from 'aurora-components';
import { FooterButtons } from 'aurora-section-components';

import styles from './styles';

const PreviewDocModal = ({
  classes,
  openModal,
  document,
  blob,
  title,
  applicationId,
  applicationType,
  closeModalHandler,
  downloadDocHandler,
}) => {
  const dispatch = useDispatch();
  const [pdfBlob, setPdfBlob] = useState(blob);

  const { loading: commonLoading, error: commonError } = useSelector(stateReducer => stateReducer.commonReducer);

  useEffect(() => {
    if (!isEmpty(document)) {
      const payload = {
        applicationId,
        applicationType,
        documentType: document.type,
        subType: document?.subType,
        fileName: document?.fileName,
      };

      dispatch(previewDocuments(payload))
        .then(response => response.arrayBuffer())
        .then(data => {
          // Create a blob from the array buffer
          const blobDoc = new Blob([data], { type: 'application/pdf' });
          setPdfBlob(blobDoc);
          closeModalHandler();
        });
    }
  }, [dispatch, document, applicationId, applicationType]);

  const clearCommonError = () => {
    dispatch({
      type: COMMON_REDUCER_CLEAR_ERROR,
    });
  };

  const savePDFHandler = () => {
    if (!isEmpty(document)) {
      const payload = {
        applicationId,
        applicationType,
        documentType: document?.type,
        subType: document?.subType,
        fileName: document?.fileName,
      };
      typeof downloadDocHandler === 'function' && downloadDocHandler(payload, document);
    } else {
      typeof downloadDocHandler === 'function' && downloadDocHandler(blob);
    }
  };

  return (
    <ADGMResponsiveModal
      title={keyEmptyCheck(title)}
      open={openModal}
      toggleModal={closeModalHandler}
      onClose={closeModalHandler}
      customClasses={{ modal: classes.modal, content: classes.content }}
    >
      {commonLoading && <Loading />}
      {commonError && <ADGMSnackbar message={commonError?.message || commonError} onClose={clearCommonError} />}
      {pdfBlob && (
        <embed
          title='PDF Viewer'
          src={URL.createObjectURL(pdfBlob)}
          type='application/pdf'
          className={classes.pdfArea}
        />
      )}

      <FooterButtons
        previousBtnText='close'
        nextBtnText='download'
        handleNext={savePDFHandler}
        handleBack={closeModalHandler}
        customClasses={{ container: classes.actionsContainer, btn: classes.actionBtn }}
      />
    </ADGMResponsiveModal>
  );
};

PreviewDocModal.propTypes = {
  classes: PropTypes.object.isRequired,
  openModal: PropTypes.bool.isRequired,
  document: PropTypes.object,
  blob: PropTypes.any,
  title: PropTypes.string,
  applicationId: PropTypes.string,
  applicationType: PropTypes.string,
  closeModalHandler: PropTypes.func.isRequired,
  downloadDocHandler: PropTypes.func.isRequired,
};

PreviewDocModal.defaultProps = {
  document: {},
  applicationId: '',
  applicationType: '',
  blob: null,
  title: 'Preview',
};

export default withStyles(styles)(PreviewDocModal);
